"use client"

import { useEffect, useState } from "react"
import { useLanguage } from "../context/LanguageContext"

const languages = [
  { code: "en", flag: "🇬🇧" },
  { code: "es", flag: "🇪🇸" },
  { code: "de", flag: "🇩🇪" },
  { code: "da", flag: "🇩🇰" },
  { code: "pt", flag: "🇵🇹" },
  { code: "it", flag: "🇮🇹" },
  { code: "fr", flag: "🇫🇷" },
  { code: "pl", flag: "🇵🇱" },
  { code: "uk", flag: "🇺🇦" },
  { code: "ru", flag: "🇷🇺" },
]

export default function LanguageSwitcher({ className = "" }) {
  const { language, changeLanguage } = useLanguage()
  const [selected, setSelected] = useState(language)

  useEffect(() => {
    setSelected(language)
  }, [language])

  const handleChange = (e) => {
    const lang = e.target.value
    changeLanguage(lang)
  }

  return (
    <select
      value={selected}
      onChange={handleChange}
      className={`px-3 py-1 border rounded-md text-3xl bg-white shadow-sm hover:cursor-pointer ${className}`}
    >
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.flag}
        </option>
      ))}
    </select>
  )
}
